import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ChartsPage from './pages/ChartsPage';
import StocksPage from './pages/StocksPage';
import BondsPage from './pages/BondsPage';
import IndicesPage from './pages/IndicesPage';
import CommoditiesPage from './pages/CommoditiesPage';
import CryptoPage from './pages/CryptoPage';
import ForexPage from './pages/ForexPage';
import SourcesPage from './pages/SourcesPage';
import RatesPage from './pages/RatesPage';
import ConsumersPage from './pages/ConsumersPage';
import NewsSourcesPage from './pages/NewsSourcesPage';
import Layout from './components/Layout';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem('mds_auth') === 'true';
  });

  const handleLogin = () => {
    sessionStorage.setItem('mds_auth', 'true');
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('mds_auth');
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <BrowserRouter>
      <Layout onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/charts" element={<ChartsPage />} />
          <Route path="/stocks" element={<StocksPage />} />
          <Route path="/bonds" element={<BondsPage />} />
          <Route path="/indices" element={<IndicesPage />} />
          <Route path="/commodities" element={<CommoditiesPage />} />
          <Route path="/crypto" element={<CryptoPage />} />
          <Route path="/forex" element={<ForexPage />} />
          <Route path="/sources" element={<SourcesPage />} />
          <Route path="/rates" element={<RatesPage />} />
          <Route path="/consumers" element={<ConsumersPage />} />
          <Route path="/news-sources" element={<NewsSourcesPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

function Placeholder({ title, count }: { title: string; count: number }) {
  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: '8px' }}>{title}</h1>
      <p style={{ color: '#7B8399', fontSize: '0.85rem' }}>{count.toLocaleString('de-DE')} Einträge — Verwaltung kommt als nächstes</p>
      <div style={{
        marginTop: '24px', padding: '40px', textAlign: 'center',
        backgroundColor: '#151921', border: '1px dashed #2A3040', borderRadius: '12px',
        color: '#4A5068', fontSize: '0.8rem',
      }}>
        Tabelle wird hier angezeigt
      </div>
    </div>
  );
}

export default App;
